import { github } from "@code-surfer/themes"

export default {
  ...github,
}
